import React from 'react';
import { toast, Toaster, ToastBar } from 'react-hot-toast';
import './ToastNotifications.css';

/**
 * Toast notification component for better user feedback
 */
const ToastNotifications = () => {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: '#363636',
          color: '#fff',
          borderRadius: '8px',
          padding: '16px',
          fontSize: '14px',
          fontWeight: '500',
        },
        success: {
          duration: 3000,
          iconTheme: {
            primary: '#4ade80',
            secondary: '#fff',
          },
        },
        error: {
          duration: 5000,
          iconTheme: {
            primary: '#ef4444',
            secondary: '#fff',
          },
        },
        loading: {
          duration: Infinity,
        },
      }}
    >
      {/* Every pop-up carries its own × (operator 2026-10-14: "need the option
          to close it instead of waiting for it to disappear"). Loading toasts
          are closed by the code that opened them, so they get no ×. */}
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {message}
              {t.type !== 'loading' && (
                <button
                  type="button"
                  className="toast-close"
                  onClick={() => toast.dismiss(t.id)}
                  aria-label="Close this message"
                  title="Close"
                >
                  ×
                </button>
              )}
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
};

// Toast utility functions
export const showSuccess = (message) => toast.success(message);
export const showError = (message) => toast.error(message);
export const showLoading = (message) => toast.loading(message);
export const showInfo = (message) => toast(message, { icon: 'ℹ️' });
export const dismissToast = (toastId) => toast.dismiss(toastId);

export default ToastNotifications;
